import { getSurfaceOrigins,getPrimaryOrigin,isProductionEnv,isStagingEnv } from '@supabank/config/domain';
type Surface='public'|'admin';
const MAP:Record<Surface,'web'|'admin'>={ public:'web',admin:'admin' };
const select=(surface:Surface,fn:(url:string)=>boolean,fallback:string)=>{const origins=getSurfaceOrigins(MAP[surface]);return origins.find(fn)||fallback;};
export function getDomain(surface:Surface){
  if(typeof window!=='undefined'){const origin=window.location.origin;const host=new URL(origin).hostname;return select(surface,url=>{try{return new URL(url).hostname===host;}catch{return false;}},origin);}
  if(isProductionEnv())return getPrimaryOrigin(MAP[surface]);
  if(isStagingEnv())return select(surface,url=>url.includes('staging'),getPrimaryOrigin(MAP[surface]));
  const origins=getSurfaceOrigins(MAP[surface]);return origins.find(o=>o.includes('localhost'))||origins[0]||'http://localhost:5173';
}
export const getPostAuthRedirect=(surface:Surface)=>surface==='admin'?'/admin':'/dashboard';
